import { createAsyncThunk } from "@reduxjs/toolkit";
import appDataService from "../../../services/appData";

export const getRoles = createAsyncThunk(
  "appData/getRoles",
  async (args: { hasAdmin: boolean }, thunkAPI) => {
    try {
      return await appDataService.getRoles(args);
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.message);
    }
  }
);

export const getSectors = createAsyncThunk(
  "appData/getSectors",
  async (args: { hasAdmin: boolean; gpLeadSectors: string[] }, thunkAPI) => {
    try {
      return await appDataService.getSectors(args);
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.message);
    }
  }
);

export const getPregeneratedQuestions = createAsyncThunk(
  "appData/getPregeneratedQuestions",
  async (args, thunkAPI) => {
    try {
      return await appDataService.getPregeneratedQuestions();
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.message);
    }
  }
);
